export { default as DataFormatting } from "./dataFormatting";



// WEBPACK FOOTER //
// ./src/utils/data_formatting/index.js